/**
 * Мост к нативной оболочке телефона точки (Capacitor, плагин `Skup`).
 *
 * Экраны `/m/*` грузятся с сервера, а камера, очередь выгрузки и звонки
 * живут в APK. Оболочка подкладывает мост только своему адресу; в обычном
 * браузере его нет — экраны тогда честно говорят, что снимать можно только
 * в приложении: галереи нет, живые фото только камерой (D-26).
 */

export interface QueueFailure {
  id: string
  label: string
  reason: string
}

export interface QueueStatus {
  pending: number
  failed: QueueFailure[]
}

export interface CaptureRequest {
  /** Что снимаем: товар серией или ценник ревизии */
  mode: 'item' | 'tag'
  itemId: string
  number: number
  title: string
  /** Сколько кадров нужно и сколько можно (D10) */
  min?: number
  max?: number
  /** Уже снято: «N из M» продолжается, а не начинается заново */
  already?: number
  /** Ревизия, которую закрывает снимок ценника */
  revisionId?: string
  /**
   * Партия (шаг 9): сколько штук нашли на полке. Приложение кладёт число
   * полем формы `counted` в выгрузку ценника; у лица партии сервер без него
   * ревизию не закрывает
   */
  counted?: number
  shiftId: string
}

export interface CaptureResult {
  /** Сколько кадров встало в очередь выгрузки */
  queued: number
  /** Нажато «Готово» — «снято» уйдёт последним в очереди */
  finished: boolean
  /** Ценник: что прочитано в QR с кадра */
  qr?: string | null
}

export interface SkupNative {
  capture(request: CaptureRequest): Promise<CaptureResult>
  queueStatus(): Promise<QueueStatus>
  retryFailed(): Promise<void>
  scanEnroll(): Promise<{ link: string | null }>
  checkUpdate(options?: { loud?: boolean }): Promise<void>
  permissions(): Promise<{ groups: Record<string, boolean>; version: number }>
  requestPermission(options: { group: string }): Promise<unknown>
  collectCalls(): Promise<void>
  reload(): Promise<void>
  addListener(event: 'queue', handler: (status: QueueStatus) => void): Promise<{ remove: () => void }>
}

export function skupNative(): SkupNative | null {
  if (!import.meta.client) return null
  const bridge = (window as unknown as { Capacitor?: { Plugins?: { Skup?: SkupNative } } }).Capacitor
  return bridge?.Plugins?.Skup ?? null
}
